import { useQuery } from "react-query";
import { AxiosError } from "axios";
import { useDispatch } from "react-redux";
import Cookies from "js-cookie";
import axiosInstance from "./axiosInstance";
import { UserDataRes } from "../../types/UserDataType";
import { updateUserData } from "../Slices/UserSlice";

export const useUserProfile = (options?: { enabled?: boolean }) => {
  const dispatch = useDispatch();

  return useQuery<UserDataRes, AxiosError>(
    ["users/updateUser"],
    async () => {
      const response = await axiosInstance.post<UserDataRes>(
        "users/updateUser",
        {},
        {
          headers: {
            "x-custom-header": "Web",
          },
        },
      );
      const userData = response.data?.data;
      if (!userData) {
        throw new Error("Invalid user profile response");
      }
      // if account deleted then redirect to login
      if (userData.deleted_at) {
        Cookies.remove("whoxa_web_token");
        sessionStorage.clear();
        localStorage.clear();
        if (window.location.pathname !== "/login") {
          window.location.href = "/login";
        }
      }
      // Dispatch user data to Redux
      dispatch(updateUserData(userData));

      const cookieLang = Number(Cookies.get("language_id") || 0);
      const serverLang = Number(userData.language_id || 0);
      if (cookieLang > 0 && cookieLang !== serverLang) {
        void axiosInstance
          .post(
            "users/updateUser",
            { language_id: cookieLang },
            { headers: { "x-custom-header": "Web" } },
          )
          .catch(() => undefined);
      } else if (!cookieLang && serverLang > 0) {
        Cookies.set("language_id", String(serverLang), { expires: 365 });
      }
      return response.data;
    },
    {
      staleTime: Infinity,
      cacheTime: Infinity,
      enabled: options?.enabled ?? true,
    },
  );
};
